"use client";

import { ErrorReportList } from "@/components/errors/error-report-list";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  dismissErrorReports,
  useErrorReportEnvironment,
  useErrorReports,
} from "@/lib/errors/report";

/**
 * 画面のエラーダイアログ（ルートのレイアウトに 1 つだけ置く・#456）。
 *
 * @remarks
 * `lib/errors/report.ts` に積まれたエラーを全部、最初から展開して出す。**明示的に「閉じる」を押すまで
 * 閉じない**（Esc・外側のクリックでは閉じない）。利用者にスクリーンショットを送ってもらう前提で、
 * 1 件の項目（発生日時・エラー ID・リクエスト・応答・メッセージ・スタック・画面・利用者・版）は
 * `lib/errors/format.ts` で決める。
 */
export function ErrorReportDialog() {
  const reports = useErrorReports();
  const env = useErrorReportEnvironment();
  return (
    <Dialog open={reports.length > 0}>
      <DialogContent
        showCloseButton={false}
        onEscapeKeyDown={(event: KeyboardEvent) => event.preventDefault()}
        onInteractOutside={(event: Event) => event.preventDefault()}
        className="flex max-h-[95vh] flex-col gap-3 sm:max-w-5xl"
        data-testid="error-report-dialog"
      >
        <DialogHeader className="min-w-0">
          <DialogTitle className="text-destructive">エラーが発生しました</DialogTitle>
          <DialogDescription>
            この画面のスクリーンショットを撮って、問い合わせ先へ送ってください（「すべてコピー」で文字でも送れます）。
          </DialogDescription>
        </DialogHeader>
        <ErrorReportList
          reports={reports}
          env={env}
          actions={
            <Button type="button" onClick={dismissErrorReports}>
              閉じる
            </Button>
          }
        />
      </DialogContent>
    </Dialog>
  );
}
